import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Http, Headers, Response, RequestOptions } from '@angular/http'
import 'rxjs/add/operator/toPromise'
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
declare var jQuery:any;


import {GlobalEventsManager} from "../_services/globaleventsmanager.service";

import { AppSettings } from '../_models/settings.models'

@Component({
  selector: 'cabecera',
  templateUrl: 'cabecera.template.html'
})
export class CabeceraComponent {

  nombre: string = '';
  entorno: string = "";

  constructor(private router:Router,
              private http: Http,
              private globalEventsManager: GlobalEventsManager){

      //this.nombre = localStorage.getItem('currentUserName');

      this.entorno = AppSettings.ENTORNO;

      this.globalEventsManager.nombreUsuarioEmitter.subscribe((mode)=>{
              // mode will be null the first time it is created, so you need to igonore it when null
              if (mode != null) {
                this.nombre = mode;
              }
          });

      this.globalEventsManager.getNombreUsuario();

  }

}



// WEBPACK FOOTER //
// ./src/app/cabecera/cabecera.component.ts